import localeText from "./localeText";

export function getLocalizedValue<
    T extends Record<string, unknown>,
>(
    locale: number,
    data: {localization: Array<{locale: number | string } & T>} & any,
    key: keyof Omit<T, 'locale'>,
    defaultValue?: string,
): Omit<T, 'locale'>[keyof Omit<T, 'locale'>] {
    const localization = data.localization.find((item) => {
        return item.locale === locale;
    });

    if (localization) {
        return localization[key] || defaultValue;
    }

    // @TODO fix this :'(
    return data[key] as any || defaultValue;
}


export const getDestinationLocalizedValue = (destination : any, current_locale: number) => getLocalizedValue(Number(current_locale), { localization: (destination?.data?.localization || []) }, 'name') || destination?.data?.name || destination?.data?.international_name;

/**
 * Nom localisé d'une destination, quelle que soit sa forme renvoyée par l'API : imbriquée sous `data`
 * (produit/zone géographique — voir `destination-zone-list`) ou à plat (`destinations/flash_search`).
 * Repli sur `#id` si rien n'est résolu (nom vide/champ manquant). Passe par `localeText` (pas
 * `getLocalizedValue` ci-dessus) — signature plus simple, pas d'inférence générique à satisfaire ici.
 */
export const getDestinationDisplayName = (
    destination: { id: number, name?: string, international_name?: string, localization?: Array<{ locale: number, name?: string }> | null, data?: { name?: string, international_name?: string, localization?: Array<{ locale: number, name?: string }> | null } | null },
    main_locale: number | null,
): string => {
    const version = destination.data ?? destination;
    const fallback = version.name || version.international_name || `#${destination.id}`;
    return localeText(main_locale, version.localization ?? [], fallback, 'name') || `#${destination.id}`;
};